<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 稽查管理  
        </el-breadcrumb-item>
        <el-breadcrumb-item>配置预警参数</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <!-- <el-row>
            <el-col :span="5">
              <el-form-item label="产品编码" prop="productCode">
                <el-input v-model="searchform.productCode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产批次" prop="batchNo" label-width="120px">
                <el-input v-model="searchform.batchNo" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="预警时间" prop="datelist" >
                   <el-date-picker
                           style="width:90%"
                           v-model="searchform.datelist"
                           type="daterange"
                           value-format="yyyy-MM-dd hh:mm:ss"
                           range-separator="-"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                   </el-date-picker>
              </el-form-item>
            </el-col>     
          </el-row>
                      <el-row>
            <el-col :span="8" :offset="1"> 
               <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['queryconsumerwarning_select']">搜索</el-button>
            </el-col>
            </el-row>  -->
        </el-form>
      </div>
<br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>配置预警参数</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            @cell-click="danhang"
          >
            <el-table-column prop="confKey" label="配置key" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="confValue" label="配置值" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="confDesc" label="中文描述" min-width="250" show-overflow-tooltip></el-table-column>
            <el-table-column prop="caozuo" label="操作" min-width="100" show-overflow-tooltip>
                  
                <el-button type="primary" plain  @click="update()" v-permission="['warningparam_update']">配置预警参数</el-button>
                
            </el-table-column>
          </el-table>
        <!-- 修改弹窗 -->
           <el-dialog title="配置预警参数" :visible.sync="editVisible" width="28%" center>
            <el-form :model="form" ref="form" label-width="100px"  :rules="rules">
              <el-row>             
                <el-form-item label="配置值" prop="confValue">
                  <el-input v-model="form.confValue" style="width:90%"></el-input>
                </el-form-item>            
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="editVisible = false">取 消</el-button>
              <el-button type="primary" @click="updateconfig('form')">确 定</el-button>
            </span>
          </el-dialog>
          <br />
          <!-- <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { findconfig,updateconfig } from "@/api/physical";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
  },
  data() {
        // 验证账号
    function validateconfValue(rule, value, callback) {
      var MobileRegex = /^0\.[0-9]\d*$/;
      if (!MobileRegex.test(value)) {
        callback(new Error("账号必须为小数！"));
      } else {
        callback();
      }
    }
    return {
      //基础数据
      editVisible:false,
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据

      searchform: {
        page:1,
        pageSize:10
      },
      form:{
          confValue:null
      },
      //基础表单验证
      rules: {
        confValue: [
          { required: true, message: "请输入预警参数", trigger: "blur" },
          { validator: validateconfValue, trigger: "blur" }
        ],
      }
    };
  },
  methods: {
        // 时间戳转正常日期
    timestampToTime(timestamp) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var  Y = date.getFullYear() + '-';
     var  M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      var  D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
      var  h = (date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':';
     var   m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ':';
     var   s = (date.getSeconds() < 10 ? '0'+(date.getSeconds()) : date.getSeconds());
        return Y+M+D+h+m+s;
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      findconfig(obj).then(response => {
        this.tableData = [response.data]
       
        const len = this.tableData.length;
        // for (let i = 0; i < len; i++) {
        // }
        // this.total_count = response.data.totalCount;
        // this.currentPage = response.data.page;
        this.listLoading = false;
        console.log(this.tableData)
      });
    },
    //表格单行点击
    danhang(row){
         this.form.confValue = row.confValue
         console.log(row)
    },
    //修改预警参数
    update(obj){
        this.editVisible = true;
    },
    updateconfig(formName){
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          updateconfig({confValue:this.form.confValue}).then(response => {
              if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "修改成功!"
              });
              this.Tabledata();
               this.editVisible = false;
            } else {
              this.$message({
                type: "woring",
                message: "修改失败!服务器出错"
              });
            }
          });
           } else {
          return false;
        }
      });
    },
    //搜索事件
    // search() {
    //     this.Tabledata({
    //     pageSize:this.searchform.pageSize
    //     });
    // },
    // //重置按钮
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    // //分页跳转事件
    // currentchange(page) {
    //   this.searchform.page = page
    //    this.Tabledata({
    //     currPage:this.searchform.page,
    //     pageSize:this.searchform.pageSize
    //     });
    //   console.log(page)
    // },
    // //分页每页显示条数事件
    // pagesize(pageSize) {
    //   this.searchform.pageSize = pageSize
    //   this.search()
    // },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>